import { useState } from "react";
import { Button } from "@workspace/amarmeds-ds/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@workspace/amarmeds-ds/components/ui/card";
import { Input } from "@workspace/amarmeds-ds/components/ui/input";
import { Label } from "@workspace/amarmeds-ds/components/ui/label";

import { api, ApiError, type Me } from "../api";

// Until phone + SMS login exists, each person signs in with the access token
// ops gave them (scripts/ordering-admin.sh staff ...). It is kept on this device.
export default function Login({ onSignedIn }: { onSignedIn: (token: string) => void }) {
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const t = token.trim();
    if (!t) return;
    setBusy(true);
    setError(null);
    try {
      await api<Me>("/staff/me", { token: t });
      onSignedIn(t);
    } catch (err) {
      setError(err instanceof ApiError && err.status === 401 ? "That access code is not valid. Ask SAVON ops for yours." : "Could not reach the server.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>SAVON Staff</CardTitle>
          <CardDescription>Pharmacy, rider and ops · ফার্মেসি, রাইডার ও অপস</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="token">Access code · অ্যাক্সেস কোড</Label>
              <Input id="token" type="password" autoComplete="current-password" value={token} onChange={(e) => setToken(e.target.value)} />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <Button type="submit" className="big-tap w-full" disabled={busy || !token.trim()}>
              {busy ? "Checking…" : "Sign in · প্রবেশ করুন"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
